import { axiosAPIInstance as axios } from '../../axios-config';

const actions = {
  async createRole(_, role) {
    const response = await axios.post('/blade/roles', role);
    return response.data.role;
  },
  async getRoles() {
    const response = await axios.get('/blade/roles');
    return response.data.roles;
  },
  async getRole(_, { roleId }) {
    const { data } = await axios.get(`/blade/roles/${roleId}`);
    return data;
  },
  async updateRole(_, role) {
    const response = await axios.patch(`/blade/roles/${role._id}`, role);
    return response.data.role;
  },
  async deleteRole(_, { roleId, _id }) {
    const did = roleId || _id;
    const response = await axios.delete(`/blade/roles/${did}`);
    return response.data.role;
  }
};

export default {
  actions
};



// WEBPACK FOOTER //
// ./src/store/blade/roles.js